const directoryApiHeaders = {};

export const createRequest = (url) => ({url, directoryApiHeaders, credentials: "include"})
export const createPostRequest = (url, body) => ({
    url, directoryApiHeaders, method: "POST", credentials: "include", body
})
